import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Plus, GitBranch, Trash2, Play } from 'lucide-react'
import { useEmailFlows, useCrearFlujo, useEliminarFlujo, useEjecutarFlujo } from '../hooks/useEmailFlows'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'

export function FlowListPage() {
  useDocumentTitle('Doppler Beta — Flujos')
  const navigate = useNavigate()
  const { data: flujos, isLoading } = useEmailFlows()
  const crearFlujo = useCrearFlujo()
  const eliminarFlujo = useEliminarFlujo()
  const ejecutarFlujo = useEjecutarFlujo()

  async function handleNuevoFlujo() {
    const flujo = await crearFlujo.mutateAsync({
      nombre: 'Nuevo flujo',
      descripcion: '',
      definicion_json: { nodes: [], edges: [] },
    })
    navigate(`/doppler-flows/${flujo.id}`)
  }

  if (isLoading) {
    return (
      <div className="p-6 flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
      </div>
    )
  }

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold">Doppler Beta — Flujos de Email</h1>
          <p className="text-sm text-gray-500 mt-1">Automatizaciones de email con From Doppler</p>
        </div>
        <Button onClick={handleNuevoFlujo} className="bg-blue-800 hover:bg-blue-900 text-white">
          <Plus size={16} className="mr-2" /> Nuevo Flujo
        </Button>
      </div>

      {(!flujos || flujos.length === 0) ? (
        <Card className="border border-gray-300 dark:border-gray-700">
          <CardContent className="py-12 text-center text-gray-400">
            <GitBranch size={40} className="mx-auto mb-3 opacity-40" />
            <p>No hay flujos aún. Crea el primero.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-3">
          {flujos.map((flujo) => (
            <Card
              key={flujo.id}
              className="border border-gray-300 dark:border-gray-700 cursor-pointer hover:border-blue-400 transition-colors"
              onClick={() => navigate(`/doppler-flows/${flujo.id}`)}
            >
              <CardHeader className="py-3">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-base">{flujo.nombre}</CardTitle>
                  <div className="flex gap-2" onClick={(e) => e.stopPropagation()}>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => ejecutarFlujo.mutate(flujo.id)}
                    >
                      <Play size={12} className="mr-1" /> Ejecutar
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => eliminarFlujo.mutate(flujo.id)}
                    >
                      <Trash2 size={12} />
                    </Button>
                  </div>
                </div>
                {flujo.descripcion && (
                  <p className="text-sm text-gray-500">{flujo.descripcion}</p>
                )}
              </CardHeader>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}
